import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApplicationStatusEnum, ApplicationUser, Location, OrgUnit, SubjectArea } from '@tran-monorepo/interfaces';
import { subjectAreasAtLeastOneRequired } from '../../../utils';
import { BudgetFormGroup, KpiSelectorFormGroup } from '../../form';
import {
    ApplicationDetailForm,
    ApplicationImpactCriteriaForm,
    ApplicationInformationForm,
    ApplicationResponsibilitiesForm,
    ApplicationSubjectAreasForm
} from '../application-detail.form';

export function createApplicationDetailForm(): ApplicationDetailForm {
    return new FormGroup({
        information: new FormGroup({
            name: new FormControl<string>('', {
                nonNullable: true,
                validators: [Validators.required]
            }),
            affectedLocations: new FormControl<Location[]>([], {
                nonNullable: true,
                validators: [Validators.required]
            }),
            involvedOrganizations: new FormControl<OrgUnit[]>([], {
                nonNullable: true
            }),
            applicants: new FormControl<ApplicationUser[]>([], {
                nonNullable: true,
                validators: [Validators.required]
            })
        }) as ApplicationInformationForm,
        responsibilities: new FormGroup({
            learningAndGrowthPartner: new FormControl<ApplicationUser | null>(null, {
                validators: [Validators.required]
            }),
            workersCouncil: new FormControl<ApplicationUser | null>(null, {
                validators: [Validators.required]
            }),
            additionalPartners: new FormControl<ApplicationUser[] | null>(null),
            businessResponsible: new FormControl<ApplicationUser | null>(null),
            technicalResponsible: new FormControl<ApplicationUser | null>(null, { validators: [Validators.required] }),
            commercialResponsible: new FormControl<ApplicationUser | null>(null, { validators: [Validators.required] })
        }) as ApplicationResponsibilitiesForm,
        subjectAreas: new FormGroup(
            {
                subjectAreas: new FormControl<SubjectArea[]>([], { nonNullable: true }),
                additionalSubjectAreas: new FormArray<FormControl<string>>([])
            },
            { validators: [subjectAreasAtLeastOneRequired] }
        ) as ApplicationSubjectAreasForm,
        impactCriteria: new FormGroup({
            contribution: new FormControl<string>('', { nonNullable: true }),
            involvement: new FormControl<string>('', { nonNullable: true }),
            transferAndScalability: new FormControl<string>('', { nonNullable: true }),
            kpis: new FormArray<KpiSelectorFormGroup>([])
        }) as ApplicationImpactCriteriaForm,
        status: new FormGroup({
            status: new FormControl<ApplicationStatusEnum | null>(null),
            awardCommitteeMeetingId: new FormControl<string | null>(null),
            isMailCommunicationDisabled: new FormControl<boolean>(false, { nonNullable: true })
        }),
        startDate: new FormControl<Date | null>(null),
        endDate: new FormControl<Date | null>(null),
        formerProjectInformation: new FormControl<string>('', { nonNullable: true }),
        comment: new FormControl<string>('', { nonNullable: true }),
        committeeProtocol: new FormControl<string>('', { nonNullable: true }),
        managementNote: new FormControl<string>('', { nonNullable: true }),
        approvedBudget: new FormControl<number | null>(null, [Validators.min(0), Validators.max(9_999_999_999_999.99)]),
        fundingRatio: new FormControl<number | null>(null),
        affectedEmployees: new FormControl<number | null>(null, [Validators.min(1)]),
        employeeLearningHours: new FormControl<number | null>(null, [Validators.min(1)]),
        budgets: new FormArray<BudgetFormGroup>([], {
            validators: [Validators.required, Validators.minLength(1)]
        })
    }) as ApplicationDetailForm;
}
